// Determine whether it's a module or feature upgrade
export const getUpgradeProps = ({ upgradable }) => {
    if(upgradable) {
        return {
            module: 'integrations'
        }
    }

    return {
        feature: 'integrations-multiple-instances',
        useFeatureOrModuleIcon: true,
        useFeatureDescription: true
    }
}
